import React, { useState } from "react";

export default function NavbarComp() {
  const [menuOpen, setMenuOpen] = useState(false);

  const movePage = (url) => {
    window.location.href = url;
  };

  return (
    <>
      {/* NAVBAR */}
      <nav className="navbar">
        {/* LOGO LEFT */}
        <div className="logo">
          <img
            src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1777421906011-idinvitebookdark.png"
            alt="logo"
          />
        </div>

        {/* DESKTOP ACTIONS */}
        <div className="desktop-actions">
          <button
            className="btn-login"
            onClick={() =>
              movePage("https://app.idinvitebook.com/login")
            }
          >
            Login
          </button>

          <button
            className="btn-primary"
            onClick={() => movePage("/register")}
          >
            Daftar
          </button>
        </div>

        {/* HAMBURGER */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* MOBILE MENU */}
        <div className={`mobile-menu ${menuOpen ? "show" : ""}`}>
          <button
            className="mobile-login"
            onClick={() =>
              movePage("https://app.idinvitebook.com/login")
            }
          >
            Login
          </button>

          <button
            className="btn-primary"
            onClick={() => movePage("/register")}
          >
            Daftar
          </button>
        </div>
      </nav>

      {/* STYLE */}
      <style>
        {`
          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 0;
            font-family: sans-serif;
          }

          /* NAVBAR */
          .navbar {
            width: 100%;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 999;

            display: flex;
            align-items: center;
            justify-content: space-between;

            padding: 22px 40px;

            background: transparent;
          }

          /* LOGO */
          .logo {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex: 1;
          }

          .logo img {
            height: 52px;
            object-fit: contain;
            display: block;
          }

          /* DESKTOP ACTIONS */
          .desktop-actions {
            display: flex;
            align-items: center;
            gap: 14px;
          }

          /* LOGIN BUTTON DARK */
          .btn-login {
            border: 1px solid rgba(0,0,0,0.08);
            background: rgba(0,0,0,0.75);
            color: #fff;

            padding: 12px 22px;
            border-radius: 14px;

            font-size: 14px;
            font-weight: 600;

            cursor: pointer;
            transition: 0.3s;
          }

          .btn-login:hover {
            background: #111;
            transform: translateY(-2px);
          }

          /* PRIMARY BUTTON */
          .btn-primary {
            border: none;
            background: #ff0a8a;
            color: #fff;

            padding: 12px 24px;
            border-radius: 14px;

            font-size: 14px;
            font-weight: 700;

            cursor: pointer;
            transition: 0.3s;

            box-shadow: 0 12px 24px rgba(255,10,138,0.25);
          }

          .btn-primary:hover {
            background: #eb007d;
            transform: translateY(-2px);
          }

          /* HAMBURGER */
          .hamburger {
            width: 30px;
            display: none;
            flex-direction: column;
            gap: 6px;
            cursor: pointer;
            z-index: 1001;
          }

          .hamburger span {
            width: 100%;
            height: 3px;
            background: #ff0a8a;
            border-radius: 999px;
            transition: 0.3s;
          }

          /* ACTIVE */
          .hamburger.active span:nth-child(1) {
            transform: rotate(45deg) translateY(12px);
          }

          .hamburger.active span:nth-child(2) {
            opacity: 0;
          }

          .hamburger.active span:nth-child(3) {
            transform: rotate(-45deg) translateY(-12px);
          }

          /* MOBILE MENU */
          .mobile-menu {
            display: none;
          }

          /* RESPONSIVE */
          @media (max-width: 768px) {
            .navbar {
              padding: 16px 20px;
              display:flex;
              flex-direction:row;
              background: rgba(255,255,255,0.96);
              backdrop-filter: blur(12px);

              box-shadow: 0 10px 30px rgba(0,0,0,0.05);
            }

            /* LOGO LEFT */
            .logo {
              flex: unset;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }

            .logo img {
              height: 42px;
            }

            /* HIDE DESKTOP */
            .desktop-actions {
              display: none;
            }

            /* HAMBURGER RIGHT */
            .hamburger {
              display: flex;
              margin-left: auto;
            }

            /* MOBILE DROPDOWN */
            .mobile-menu {
              position: absolute;
              top: 100%;
              left: 16px;
              right: 16px;

              background: #fff;
              border-radius: 22px;
              padding: 20px;

              box-shadow: 0 25px 50px rgba(0,0,0,0.08);

              display: flex;
              flex-direction: column;
              gap: 14px;

              opacity: 0;
              visibility: hidden;
              transform: translateY(-10px);
              transition: 0.3s;
            }

            .mobile-menu.show {
              opacity: 1;
              visibility: visible;
              transform: translateY(0);
            }

            /* MOBILE LOGIN */
            .mobile-login {
              width: 100%;
              border: 1px solid #eee;
              background: #111;
              color: #fff;

              padding: 12px 18px;
              border-radius: 14px;

              font-size: 14px;
              font-weight: 600;

              cursor: pointer;
            }

            .mobile-menu .btn-primary {
              width: 100%;
            }
          }

          @media (max-width: 480px) {
            .navbar {
              padding: 14px 16px;
            }

            .logo img {
              height: 38px;
            }

            .mobile-menu {
              left: 14px;
              right: 14px;
              padding: 18px;
              border-radius: 18px;
            }

            .mobile-login,
            .btn-primary {
              padding: 12px 18px;
              font-size: 14px;
            }
          }
        `}
      </style>
    </>
  );
}